import type { Business } from '@/modules/dashboard/dashboardTypes';
import { useRef, useState } from 'react';

type AboutSessionProps = Pick<NonNullable<Business['yelp']>, 'about'>;

export const AboutSession = ({ about }: AboutSessionProps) => {
	const titleRef = useRef<HTMLElement>(null);

	const [showAboutMore, setShowAboutMore] = useState(false);

	if (!about) return null;

	const handleToggleAbout = () => {
		setShowAboutMore(state => {
			if (state) {
				titleRef.current?.scrollIntoView({
					behavior: 'smooth',
					block: 'end'
				});
			}

			return !state;
		});
	};

	return (
		<div className="flex w-full flex-col gap-2">
			<strong
				className="flex items-center font-semibold text-dm-mid-grey"
				ref={titleRef}
			>
				About
			</strong>

			<p
				data-show-more={showAboutMore}
				className="line-clamp-2 w-full overflow-hidden text-ellipsis text-sm font-light text-dm-white duration-300 ease-in-out data-[show-more=true]:line-clamp-none"
			>
				{about}
			</p>

			{about.length > 115 && (
				<button
					type="button"
					className="ml-auto cursor-pointer text-sm font-semibold text-dm-white"
					onClick={handleToggleAbout}
				>
					{showAboutMore ? 'show less' : '...show more'}
				</button>
			)}
		</div>
	);
};
